/**
 * SEE-1787: the backend settings `Amplify.configure` needs, from `REACT_APP_*` build values
 * instead of the Amplify-generated `aws-exports.js`.
 *
 * The keys are the ones `aws-exports.js` used, so Amplify v4 reads them exactly as before. That
 * matters beyond Amplify itself: its localStorage keys are the mobile SSO contract (see the note
 * in `index.tsx`). The values come from `/speedchain/{stage}/web-config/` in a CDK build
 * (`scripts/write-web-env.sh`), from `aws-exports.js` in an Amplify build
 * (`scripts/env-from-aws-exports.js`), and for `yarn start` from a local `aws-exports.js` when there
 * is one (`scripts/start.js`), otherwise from `.env.development` / `.env.local`.
 *
 * aws-exports' Cognito sign-up, MFA and password-policy keys are left out on purpose: only
 * Amplify's UI components read them, and the app doesn't use those.
 *
 * Nothing here throws on a missing value. Jest runs without any of them, and a build that is
 * missing one fails earlier, in `scripts/check-web-env.js`.
 */
const region = process.env.REACT_APP_AWS_REGION;

const awsConfig = {
  aws_project_region: region,
  aws_cognito_region: region,
  aws_appsync_region: region,
  aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL_ID,
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};

export default awsConfig;
